import { overtimePay } from "../utils/monthlySalary";
import { registerStyles } from "../utils/registerStyles";
import { resolvePayrollTime } from "../utils/payrollTime";
// src/pages/PayrollPage.js
// Uppdaterad: OB-beräkning räknar varje OB-källa separat (samma som TimeReportPopup)
// Uppdaterad: Inkluderar även egna OB-tillägg (customObEntries) i OB-beräkningen
// Uppdaterad: Valutaformatering visar nu ören (2 decimaler)

import React, { useEffect, useMemo, useState } from "react";
import LoadingIndicator from "../components/LoadingIndicator";
import { calculateAbsencePay } from "../utils/absencePay";
import {
  FaMoneyBill,
  FaSearch,
  FaCheck,
  FaPlus,
  FaPercentage,
  FaClock,
} from "react-icons/fa";
import {
  collection,
  doc,
  onSnapshot,
  updateDoc,
  serverTimestamp,
  query,
  orderBy,
  writeBatch,
  where,
} from "firebase/firestore";
import { db } from "../firebase";
import { useAuth } from "../contexts/AuthContext";
import { useCompany } from "../contexts/CompanyContext";

import AddSalaryPopup from "../popup/AddSalaryPopup";
import AddObPopup from "../popup/AddObPopup";
import AddOvertimePopup from "../popup/AddOvertimePopup";
import AddAbsencePopup from "../popup/AddAbsencePopup";
import GlobalSettingsPopup from "../popup/GlobalSettingsPopup";
import TimeReportPopup from "../popup/TimeReportPopup";

function SemProcentPopup({ isOpen, onClose, onSave, currentValue }) {
  const [selectedPercentage, setSelectedPercentage] = useState(
    Number(currentValue || 100)
  );
  const [inputValue, setInputValue] = useState(Number(currentValue || 100));

  useEffect(() => {
    const value = Number(currentValue || 100);
    setSelectedPercentage(value);
    setInputValue(value);
  }, [currentValue, isOpen]);

  const handleSliderChange = (e) => {
    const value = parseInt(e.target.value, 10);
    setSelectedPercentage(value);
    setInputValue(value);
  };

  const handleInputChange = (e) => {
    const value = parseInt(e.target.value, 10);
    if (!isNaN(value) && value >= 0 && value <= 100) {
      setSelectedPercentage(value);
      setInputValue(value);
    }
  };

  const handleSave = () => {
    onSave?.(selectedPercentage);
    onClose?.();
  };

  if (!isOpen) return null;

  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(17, 24, 39, 0.35)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 2100,
        padding: 16,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width: "100%",
          maxWidth: 400,
          background: "#ffffff",
          borderRadius: 16,
          boxShadow: "0 12px 30px rgba(0,0,0,0.16)",
          padding: 24,
          boxSizing: "border-box",
        }}
      >
        <h3
          style={{
            margin: "0 0 8px",
            fontSize: 20,
            fontWeight: 700,
            color: "#111827",
          }}
        >
          SEM procent %
        </h3>

        <p
          style={{
            margin: "0 0 20px",
            fontSize: 14,
            color: "#6b7280",
          }}
        >
          Välj procent för löneberäkningen (0-100%)
        </p>

        <div style={{ marginBottom: 24 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <input
              type="range"
              min="0"
              max="100"
              value={selectedPercentage}
              onChange={handleSliderChange}
              style={{
                flex: 1,
                height: 6,
                borderRadius: 3,
                background: `linear-gradient(to right, #3b82f6 0%, #3b82f6 ${selectedPercentage}%, #e5e7eb ${selectedPercentage}%, #e5e7eb 100%)`,
                accentColor: "#3b82f6",
              }}
            />
            <input
              type="number"
              min="0"
              max="100"
              value={inputValue}
              onChange={handleInputChange}
              style={{
                width: 70,
                padding: "8px 12px",
                borderRadius: 8,
                border: "1px solid #d1d5db",
                fontSize: 14,
                textAlign: "center",
              }}
            />
            <span style={{ fontSize: 14, fontWeight: 600, color: "#6b7280" }}>
              %
            </span>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: 8,
              color: "#9ca3af",
              fontSize: 12,
            }}
          >
            <span>0%</span>
            <span>25%</span>
            <span>50%</span>
            <span>75%</span>
            <span>100%</span>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 10,
          }}
        >
          <button
            onClick={onClose}
            style={{
              height: 40,
              padding: "0 16px",
              borderRadius: 8,
              border: "1px solid #d1d5db",
              background: "#ffffff",
              color: "#6b7280",
              fontSize: 14,
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            Avbryt
          </button>

          <button
            onClick={handleSave}
            style={{
              height: 40,
              padding: "0 16px",
              borderRadius: 8,
              border: "1px solid #2563eb",
              background: "#3b82f6",
              color: "#ffffff",
              fontSize: 14,
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            Välj {selectedPercentage}%
          </button>
        </div>
      </div>
    </div>
  );
}

function safeParseDate(dateValue) {
  if (!dateValue) return null;

  try {
    if (dateValue instanceof Date) {
      return isNaN(dateValue.getTime()) ? null : dateValue;
    }

    if (
      typeof dateValue === "object" &&
      typeof dateValue.toDate === "function"
    ) {
      const parsed = dateValue.toDate();
      return parsed instanceof Date && !isNaN(parsed.getTime()) ? parsed : null;
    }

    if (typeof dateValue === "string" || typeof dateValue === "number") {
      const parsed = new Date(dateValue);
      return isNaN(parsed.getTime()) ? null : parsed;
    }

    return null;
  } catch (error) {
    console.error("Fel vid datumtolkning:", error);
    return null;
  }
}

function getMonthIndexFromSwedish(monthName) {
  const months = {
    Januari: 0,
    Februari: 1,
    Mars: 2,
    April: 3,
    Maj: 4,
    Juni: 5,
    Juli: 6,
    Augusti: 7,
    September: 8,
    Oktober: 9,
    November: 10,
    December: 11,
  };

  return months[monthName] ?? 0;
}

function getSwedishMonthName(monthIndex) {
  const months = [
    "Januari",
    "Februari",
    "Mars",
    "April",
    "Maj",
    "Juni",
    "Juli",
    "Augusti",
    "September",
    "Oktober",
    "November",
    "December",
  ];
  return months[monthIndex];
}

function pad(n) {
  return String(n).padStart(2, "0");
}

function formatDateKey(date) {
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
    date.getDate()
  )}`;
}

function addDays(date, days) {
  const d = new Date(date);
  d.setDate(d.getDate() + days);
  return d;
}

function normalizeDayName(day) {
  const map = {
    monday: "måndag",
    tuesday: "tisdag",
    wednesday: "onsdag",
    thursday: "torsdag",
    friday: "fredag",
    saturday: "lördag",
    sunday: "söndag",
    måndag: "måndag",
    tisdag: "tisdag",
    onsdag: "onsdag",
    torsdag: "torsdag",
    fredag: "fredag",
    lördag: "lördag",
    söndag: "söndag",
    Måndag: "måndag",
    Tisdag: "tisdag",
    Onsdag: "onsdag",
    Torsdag: "torsdag",
    Fredag: "fredag",
    Lördag: "lördag",
    Söndag: "söndag",
  };

  return map[String(day || "").trim()] || String(day || "").toLowerCase().trim();
}

function getSwedishWeekday(date) {
  const names = [
    "söndag",
    "måndag",
    "tisdag",
    "onsdag",
    "torsdag",
    "fredag",
    "lördag",
  ];
  return names[date.getDay()];
}

function timeToMinutes(timeString) {
  if (!timeString || typeof timeString !== "string") return 0;

  const [h, m] = timeString.split(":").map(Number);
  if (Number.isNaN(h) || Number.isNaN(m)) return 0;
  return h * 60 + m;
}

function calculateTotalShiftMinutes(shift) {
  if (!shift?.startTime || !shift?.endTime) return 0;

  const startMinutes = timeToMinutes(String(shift.startTime));
  const endMinutes = timeToMinutes(String(shift.endTime));

  let totalMinutes = endMinutes - startMinutes;
  if (totalMinutes < 0) {
    totalMinutes += 24 * 60;
  }

  return totalMinutes;
}

function calculateTotalBreakMinutes(employeeData) {
  let totalBreakMinutes = 0;

  if (employeeData?.breaks && Array.isArray(employeeData.breaks)) {
    employeeData.breaks.forEach((breakItem) => {
      if (breakItem.appliesToWholeShift) return;

      if (breakItem.startTime && breakItem.endTime) {
        const start = timeToMinutes(breakItem.startTime);
        const end = timeToMinutes(breakItem.endTime);

        let breakMinutes = end - start;
        if (breakMinutes < 0) {
          breakMinutes += 24 * 60;
        }
        totalBreakMinutes += breakMinutes;
      }
    });
  }

  return totalBreakMinutes;
}

function calculateShiftHours(shift, employeeData = null) {
  ({ shift, employeeData } = resolvePayrollTime(shift, employeeData));
  if (!shift?.startTime || !shift?.endTime) return 0;

  try {
    const totalMinutes = calculateTotalShiftMinutes(shift);
    let breakMinutes = 0;

    if (employeeData) {
      breakMinutes = calculateTotalBreakMinutes(employeeData);

      if (employeeData.breaks && Array.isArray(employeeData.breaks)) {
        employeeData.breaks.forEach((breakItem) => {
          if (breakItem.appliesToWholeShift) {
            const totalHours = totalMinutes / 60;
            if (totalHours >= 5 && totalHours < 8) {
              breakMinutes = Math.max(breakMinutes, 30);
            } else if (totalHours >= 8) {
              breakMinutes = Math.max(breakMinutes, 60);
            }
          }
        });
      }
    } else {
      breakMinutes = Number(shift.breakMinutes || shift.break || 0);
    }

    let workedMinutes = Math.max(0, totalMinutes - breakMinutes);

    if (employeeData?.absences && Array.isArray(employeeData.absences)) {
      employeeData.absences.forEach((absenceItem) => {
        let absenceMinutes = 0;

        if (absenceItem.appliesToWholeShift) {
          absenceMinutes = workedMinutes;
        } else if (absenceItem.startTime && absenceItem.endTime) {
          const start = timeToMinutes(absenceItem.startTime);
          const end = timeToMinutes(absenceItem.endTime);

          let minutes = end - start;
          if (minutes < 0) {
            minutes += 24 * 60;
          }
          absenceMinutes = minutes;
        } else if (Number(absenceItem.hours || 0) > 0) {
          absenceMinutes = Number(absenceItem.hours || 0) * 60;
        }

        workedMinutes = Math.max(0, workedMinutes - absenceMinutes);
      });
    }

    return workedMinutes / 60;
  } catch (error) {
    console.error("Fel vid beräkning av passets timmar:", error);
    return 0;
  }
}

function calculateOvertimeForShift(shift, employeeData = null) {
  ({ shift, employeeData } = resolvePayrollTime(shift, employeeData));
  if (!shift?.startTime || !shift?.endTime) {
    return {
      hours: 0,
      premiumValue: 0,
      regularHours: 0,
      premiumHours: 0,
    };
  }

  try {
    let totalOvertimeMinutes = 0;
    let premiumOvertimeMinutes = 0;
    let premiumValue = 0;

    if (employeeData?.overtime && Array.isArray(employeeData.overtime)) {
      employeeData.overtime.forEach((overtimeItem) => {
        let itemMinutes = 0;

        if (overtimeItem.appliesToWholeShift) {
          const totalMinutes = calculateTotalShiftMinutes(shift);
          const breakMinutes = calculateTotalBreakMinutes(employeeData);
          itemMinutes = Math.max(0, totalMinutes - breakMinutes);
        } else if (overtimeItem.startTime && overtimeItem.endTime) {
          const start = timeToMinutes(overtimeItem.startTime);
          const end = timeToMinutes(overtimeItem.endTime);

          let minutes = end - start;
          if (minutes < 0) {
            minutes += 24 * 60;
          }
          itemMinutes = minutes;
        } else if (Number(overtimeItem.hours || 0) > 0) {
          itemMinutes = Number(overtimeItem.hours || 0) * 60;
        }

        const percentage = Number(overtimeItem.percentage || 0);
        totalOvertimeMinutes += itemMinutes;

        if (percentage > 0) {
          premiumOvertimeMinutes += itemMinutes;
          premiumValue += (itemMinutes / 60) * (percentage / 100);
        }
      });
    }

    return {
      hours: totalOvertimeMinutes / 60,
      premiumValue,
      regularHours: (totalOvertimeMinutes - premiumOvertimeMinutes) / 60,
      premiumHours: premiumOvertimeMinutes / 60,
    };
  } catch (error) {
    console.error("Fel vid beräkning av övertid/mertid:", error);
    return { hours: 0, premiumValue: 0, regularHours: 0, premiumHours: 0 };
  }
}

function calculateAbsenceForShift(shift, employeeData = null) {
  ({ shift, employeeData } = resolvePayrollTime(shift, employeeData));
  if (!shift?.startTime || !shift?.endTime) return { hours: 0, value: 0 };

  try {
    let absenceMinutes = 0;
    let absenceValue = 0;

    if (employeeData?.absences && Array.isArray(employeeData.absences)) {
      employeeData.absences.forEach((absenceItem) => {
        let itemMinutes = 0;

        if (absenceItem.appliesToWholeShift) {
          const totalMinutes = calculateTotalShiftMinutes(shift);
          const breakMinutes = calculateTotalBreakMinutes(employeeData);
          itemMinutes = Math.max(0, totalMinutes - breakMinutes);
        } else if (absenceItem.startTime && absenceItem.endTime) {
          const start = timeToMinutes(absenceItem.startTime);
          const end = timeToMinutes(absenceItem.endTime);

          let minutes = end - start;
          if (minutes < 0) {
            minutes += 24 * 60;
          }
          itemMinutes = minutes;
        } else if (Number(absenceItem.hours || 0) > 0) {
          itemMinutes = Number(absenceItem.hours || 0) * 60;
        }

        absenceMinutes += itemMinutes;

        const salaryPercent = Number(absenceItem.absencePercent ?? absenceItem.salaryPercent ?? 0);
        const deductionPercent = (100 - salaryPercent) / 100;
        absenceValue += (itemMinutes / 60) * deductionPercent;
      });
    }

    return {
      hours: absenceMinutes / 60,
      value: absenceValue,
    };
  } catch (error) {
    console.error("Fel vid beräkning av frånvaro:", error);
    return { hours: 0, value: 0 };
  }
}

function getShiftSegments(shift) {
  const shiftDate = safeParseDate(shift?.date);
  if (!shiftDate || !shift?.startTime || !shift?.endTime) return [];

  const startMinutes = timeToMinutes(String(shift.startTime));
  const endMinutes = timeToMinutes(String(shift.endTime));

  if (startMinutes === endMinutes) return [];

  if (endMinutes > startMinutes) {
    return [
      {
        date: new Date(shiftDate),
        dateKey: formatDateKey(shiftDate),
        startMinute: startMinutes,
        endMinute: endMinutes,
      },
    ];
  }

  const nextDate = addDays(shiftDate, 1);

  return [
    {
      date: new Date(shiftDate),
      dateKey: formatDateKey(shiftDate),
      startMinute: startMinutes,
      endMinute: 1440,
    },
    {
      date: new Date(nextDate),
      dateKey: formatDateKey(nextDate),
      startMinute: 0,
      endMinute: endMinutes,
    },
  ];
}

// ============================================================
// NYA OB-HELPERS (samma som i TimeReportPopup)
// ============================================================

function getDateKey(value) {
  if (!value) return "";
  if (typeof value === "string") return value.slice(0, 10);
  const parsed = safeParseDate(value);
  return parsed ? formatDateKey(parsed) : "";
}

function sourceAppliesToMinute({
  dateKey,
  previousDateKey,
  minute,
  start,
  end,
  sourceDateKey,
}) {
  if (start <= end) {
    return sourceDateKey === dateKey && minute >= start && minute < end;
  }
  return (
    (sourceDateKey === dateKey && minute >= start && minute < 1440) ||
    (sourceDateKey === previousDateKey && minute >= 0 && minute < end)
  );
}

function getRuleDays(rule) {
  const rawDays =
    rule?.days ||
    rule?.selectedDays ||
    rule?.weekdays ||
    rule?.selectedWeekdays ||
    [];
  return Array.isArray(rawDays) ? rawDays.map(normalizeDayName) : [];
}

function getActiveObSourcesAtMinute(minute, date, obRules, holidays, customObEntries = []) {
  const sources = [];
  const dateKey = formatDateKey(date);
  const previousDate = addDays(date, -1);
  const previousDateKey = formatDateKey(previousDate);
  const currentWeekday = getSwedishWeekday(date);
  const previousWeekday = getSwedishWeekday(previousDate);

  (obRules || []).forEach((rule) => {
    const name = rule?.name || rule?.title || "OB";

    if (rule?.useSpecificDates) {
      const specificDates = Array.isArray(rule?.specificDates)
        ? rule.specificDates
        : [];

      specificDates.forEach((item) => {
        const amount = Number(
          item?.amount ??
          rule?.amount ??
          rule?.obAmount ??
          rule?.value ??
          0
        );
        if (amount <= 0) return;

        const sourceDateKey = getDateKey(item?.date);
        const start = timeToMinutes(
          item?.startTime || rule?.startTime || rule?.from || "00:00"
        );
        const end = timeToMinutes(
          item?.endTime || rule?.endTime || rule?.to || "23:59"
        );

        if (
          sourceAppliesToMinute({
            dateKey,
            previousDateKey,
            minute,
            start,
            end,
            sourceDateKey,
          })
        ) {
          sources.push({
            name: item?.name || name,
            amount,
            type: "obRule",
          });
        }
      });
      return;
    }

    const amount = Number(
      rule?.amount ??
      rule?.obAmount ??
      rule?.value ??
      0
    );
    if (amount <= 0) return;

    const start = timeToMinutes(rule?.startTime || rule?.from || "00:00");
    const end = timeToMinutes(rule?.endTime || rule?.to || "23:59");
    const days = getRuleDays(rule);

    const appliesToday = days.length === 0 || days.includes(currentWeekday);
    const appliesPreviousDay = days.length === 0 || days.includes(previousWeekday);

    if (start <= end) {
      if (appliesToday && minute >= start && minute < end) {
        sources.push({
          name,
          amount,
          type: "obRule",
        });
      }
    } else {
      if (appliesToday && minute >= start && minute < 1440) {
        sources.push({
          name,
          amount,
          type: "obRule",
        });
      }
      if (appliesPreviousDay && minute >= 0 && minute < end) {
        sources.push({
          name,
          amount,
          type: "obRule",
        });
      }
    }
  });

  (holidays || []).forEach((holiday) => {
    const amount = Number(holiday?.amount || 0);
    if (amount <= 0) return;

    const holidayDateKey = getDateKey(holiday?.date);
    const start = timeToMinutes(holiday?.startTime || "00:00");
    const end = timeToMinutes(holiday?.endTime || "23:59");

    if (
      sourceAppliesToMinute({
        dateKey,
        previousDateKey,
        minute,
        start,
        end,
        sourceDateKey: holidayDateKey,
      })
    ) {
      sources.push({
        name: holiday?.name || "Helgdag",
        amount,
        type: "holiday",
      });
    }
  });

  (customObEntries || []).forEach((customOb) => {
    const amount = Number(customOb?.amount || 0);
    if (amount <= 0) return;

    const name = customOb?.name || customOb?.description || "Eget OB-tillägg";
    const customDateKey = getDateKey(customOb?.date);
    const start = timeToMinutes(customOb?.startTime || "00:00");
    const end = timeToMinutes(customOb?.endTime || "23:59");

    if (
      sourceAppliesToMinute({
        dateKey,
        previousDateKey,
        minute,
        start,
        end,
        sourceDateKey: customDateKey,
      })
    ) {
      sources.push({
        name,
        amount,
        type: "custom",
        customObId: customOb.id,
      });
    }
  });

  return sources;
}

function buildAbsenceIntervals(segments, employeeData) {
  const absenceIntervals = [];

  if (employeeData?.absences && Array.isArray(employeeData.absences)) {
    employeeData.absences.forEach((absenceItem) => {
      if (absenceItem.appliesToWholeShift) {
        segments.forEach((segment) => {
          absenceIntervals.push({
            start: segment.startMinute,
            end: segment.endMinute,
          });
        });
      } else if (absenceItem.startTime && absenceItem.endTime) {
        const start = timeToMinutes(absenceItem.startTime);
        const end = timeToMinutes(absenceItem.endTime);

        if (end < start) {
          segments.forEach((segment) => {
            if (segment.startMinute <= start && segment.endMinute >= 1440) {
              absenceIntervals.push({ start, end: 1440 });
            }
            if (segment.startMinute <= end && segment.endMinute >= 0) {
              absenceIntervals.push({ start: 0, end });
            }
          });
        } else {
          segments.forEach((segment) => {
            const overlapStart = Math.max(segment.startMinute, start);
            const overlapEnd = Math.min(segment.endMinute, end);
            if (overlapEnd > overlapStart) {
              absenceIntervals.push({
                start: overlapStart,
                end: overlapEnd,
              });
            }
          });
        }
      }
    });
  }

  return absenceIntervals;
}

// UPPDATERAD: calculateObForShift - räknar varje OB-källa separat
function calculateObForShift(shift, obRules, holidays, obEnabled = true, employeeData = null, customObEntries = []) {
  ({ shift, employeeData } = resolvePayrollTime(shift, employeeData));
  if (!obEnabled) {
    return { hours: 0, value: 0 };
  }

  const segments = getShiftSegments(shift);
  if (segments.length === 0) {
    return { hours: 0, value: 0 };
  }

  const absenceIntervals = buildAbsenceIntervals(segments, employeeData);

  const isMinuteAbsent = (minute) => {
    return absenceIntervals.some(
      (interval) => minute >= interval.start && minute < interval.end
    );
  };

  let obMinutes = 0;
  let obValue = 0;

  segments.forEach((segment) => {
    for (let minute = segment.startMinute; minute < segment.endMinute; minute++) {
      if (isMinuteAbsent(minute)) continue;

      const activeSources = getActiveObSourcesAtMinute(
        minute,
        segment.date,
        obRules,
        holidays,
        customObEntries
      ).filter((source) => Number(source.amount || 0) > 0);

      // Varje aktiv OB-källa räknas separat
      activeSources.forEach((source) => {
        obMinutes += 1;
        obValue += Number(source.amount || 0) / 60;
      });
    }
  });

  return {
    hours: obMinutes / 60,
    value: obValue,
  };
}

// ============================================================
// SLUT PÅ NYA OB-HELPERS
// ============================================================

function getEmployeeIdFromRequest(request, employeeList = []) {
  if (!request) return null;

  if (request.employeeId) return request.employeeId;
  if (request.userId) return request.userId;
  if (request.uid) return request.uid;

  const email = String(request.userEmail || request.email || "")
    .trim()
    .toLowerCase();

  if (!email) return null;

  const employee = employeeList.find(
    (emp) => String(emp.email || "").trim().toLowerCase() === email
  );

  return employee?.id || null;
}

function buildApprovedOvertimePayrollEntry(request, overtimeRules = []) {
  const matchingRule = request?.overtimeRuleId
    ? overtimeRules.find((rule) => rule.id === request.overtimeRuleId)
    : null;

  return {
    overtimeRequestId: request.id,
    startTime: request.startTime || "",
    endTime: request.endTime || "",
    appliesToWholeShift: Boolean(request.appliesToWholeShift),
    overtimeRuleId: request.overtimeRuleId || matchingRule?.id || "approved-request",
    overtimeRuleName:
      request.overtimeRuleName || matchingRule?.name || "Godkänd övertid",
    percentage: Number(request.percentage ?? matchingRule?.percentage ?? 0),
    hours: Number(request.hours || 0),
    approvedFromRequest: true,
  };
}

function buildApprovedAbsencePayrollEntry(request, absenceTypes = []) {
  const matchingType = request?.absenceTypeId
    ? absenceTypes.find((type) => type.id === request.absenceTypeId)
    : null;

  return {
    absenceRequestId: request.id,
    startTime: request.startTime || "",
    endTime: request.endTime || "",
    appliesToWholeShift: Boolean(request.appliesToWholeShift),
    type: request.absenceTypeName || matchingType?.name || "Godkänd frånvaro",
    absenceTypeId: request.absenceTypeId || matchingType?.id || "approved-request",
    absenceTypeName:
      request.absenceTypeName || matchingType?.name || "Godkänd frånvaro",
    absencePercent: Number(
      request.absencePercent ??
        request.salaryPercent ??
        matchingType?.salaryPercent ??
        0
    ),
    hours: Number(request.hours || 0),
    approvedFromRequest: true,
  };
}

function mergeApprovedRequestsForEmployee({
  shift,
  employeeId,
  employeeData,
  approvedOvertimeRequests,
  approvedAbsenceRequests,
  employees,
  overtimeRules,
  absenceTypes,
}) {
  const shiftId = shift?.originalId || shift?.id;
  if (!shiftId || !employeeId) return employeeData;

  const baseOvertime = Array.isArray(employeeData?.overtime)
    ? employeeData.overtime.filter((entry) => !entry?.approvedFromRequest)
    : [];

  const baseAbsences = Array.isArray(employeeData?.absences)
    ? employeeData.absences.filter((entry) => !entry?.approvedFromRequest)
    : [];

  const matchingOvertimeRequests = (approvedOvertimeRequests || []).filter((request) => {
    const requestShiftId = request?.shiftId || request?.originalShiftId;
    if (requestShiftId !== shiftId) return false;

    const requestEmployeeId = getEmployeeIdFromRequest(request, employees);
    return requestEmployeeId === employeeId;
  });

  const matchingAbsenceRequests = (approvedAbsenceRequests || []).filter((request) => {
    const requestShiftId = request?.shiftId || request?.originalShiftId;
    if (requestShiftId !== shiftId) return false;

    const requestEmployeeId = getEmployeeIdFromRequest(request, employees);
    return requestEmployeeId === employeeId;
  });

  return {
    ...employeeData,
    overtime: [
      ...baseOvertime,
      ...matchingOvertimeRequests.map((request) =>
        buildApprovedOvertimePayrollEntry(request, overtimeRules)
      ),
    ],
    absences: [
      ...baseAbsences,
      ...matchingAbsenceRequests.map((request) =>
        buildApprovedAbsencePayrollEntry(request, absenceTypes)
      ),
    ],
  };
}

function buildEmployeeEntriesFromShift(
  shift,
  bookings = [],
  approvedOvertimeRequests = [],
  approvedAbsenceRequests = [],
  employees = [],
  overtimeRules = [],
  absenceTypes = []
) {
  const entries = [];
  const addedEmployeeIds = new Set();

  const addEntry = (employeeId, employeeData = {}) => {
    const normalizedEmployeeId = employeeId || null;
    const isObemannad = Boolean(employeeData?.isObemannad);

    if (!normalizedEmployeeId || isObemannad) return;
    if (addedEmployeeIds.has(normalizedEmployeeId)) return;

    addedEmployeeIds.add(normalizedEmployeeId);

    const baseEmployeeData = {
      breaks: employeeData?.breaks || [],
      overtime: employeeData?.overtime || [],
      absences: employeeData?.absences || [],
      ...employeeData,
    };

    const employeeDataWithApprovedRequests = mergeApprovedRequestsForEmployee({
      shift,
      employeeId: normalizedEmployeeId,
      employeeData: baseEmployeeData,
      approvedOvertimeRequests,
      approvedAbsenceRequests,
      employees,
      overtimeRules,
      absenceTypes,
    });

    entries.push({
      employeeId: normalizedEmployeeId,
      employeeData: employeeDataWithApprovedRequests,
    });
  };

  if (Array.isArray(shift?.employees)) {
    shift.employees.forEach((employeeData) => {
      addEntry(employeeData?.employeeId, employeeData);
    });
  } else {
    addEntry(shift?.employeeId, {
      payrollTime: shift?.payrollTime || null,
      breaks: shift?.breaks || [],
      overtime: shift?.overtime || [],
      absences: shift?.absences || [],
      employeeId: shift?.employeeId || null,
      isObemannad: shift?.isObemannad || false,
      name: shift?.name || shift?.employee || shift?.userName || "",
    });
  }

  const shiftIdentifier = shift?.originalId || shift?.id;

  bookings
    .filter((booking) => {
      const bookingShiftId = booking?.originalShiftId;
      return (
        booking?.status === "approved" &&
        booking?.userId &&
        bookingShiftId &&
        bookingShiftId === shiftIdentifier
      );
    })
    .forEach((booking) => {
      addEntry(booking.userId, {
        employeeId: booking.userId,
        name: booking.userName || "",
        breaks: [],
        overtime: [],
        absences: [],
        bookingId: booking.id,
        isFromBooking: true,
      });
    });

  return entries;
}

export default function PayrollPage() {
  const { currentUser } = useAuth();
  const { activeCompany, loading: companyLoading } = useCompany();

  const currentDate = new Date();
  const currentYear = currentDate.getFullYear().toString();
  const currentMonth = getSwedishMonthName(currentDate.getMonth());

  const [isSalaryPopupOpen, setIsSalaryPopupOpen] = useState(false);
  const [isObPopupOpen, setIsObPopupOpen] = useState(false);
  const [isOvertimePopupOpen, setIsOvertimePopupOpen] = useState(false);
  const [isAbsencePopupOpen, setIsAbsencePopupOpen] = useState(false);
  const [isSemProcentPopupOpen, setIsSemProcentPopupOpen] = useState(false);
  const [selectedSemProcentEmployee, setSelectedSemProcentEmployee] = useState(null);
  const [isGlobalSettingsPopupOpen, setIsGlobalSettingsPopupOpen] = useState(false);
  const [isTimeReportPopupOpen, setIsTimeReportPopupOpen] = useState(false);
  const [selectedTimeReportEmployee, setSelectedTimeReportEmployee] = useState(null);
  const [hiddenNetSalaries, setHiddenNetSalaries] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("payroll-hidden-net-salaries") || "{}");
    } catch {
      return {};
    }
  });

  const [globalSettingsDefaults, setGlobalSettingsDefaults] = useState({
    obEnabled: true,
    semEnabled: true,
    semProcent: 12,
    tax: 30,
    hideNetSalary: false,
  });

  const [salaryTypes, setSalaryTypes] = useState([]);
  const [obRules, setObRules] = useState([]);
  const [holidays, setHolidays] = useState([]);
  const [overtimeRules, setOvertimeRules] = useState([]);
  const [absenceTypes, setAbsenceTypes] = useState([]);
  const [bookings, setBookings] = useState([]);
  const [approvedOvertimeRequests, setApprovedOvertimeRequests] = useState([]);
  const [approvedAbsenceRequests, setApprovedAbsenceRequests] = useState([]);
  const [customObEntries, setCustomObEntries] = useState([]);

  const [searchQuery, setSearchQuery] = useState("");
  const [selectedMonth, setSelectedMonth] = useState(currentMonth);
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [toast, setToast] = useState({
    visible: false,
    message: "",
    success: true,
  });

  const [employees, setEmployees] = useState([]);
  const [shifts, setShifts] = useState([]);
  const [loading, setLoading] = useState(true);

  const monthsInSwedish = [
    "Januari",
    "Februari",
    "Mars",
    "April",
    "Maj",
    "Juni",
    "Juli",
    "Augusti",
    "September",
    "Oktober",
    "November",
    "December",
  ];

  const generateYears = () => {
    const currentYearNum = new Date().getFullYear();
    const years = [];
    for (let year = 2020; year <= currentYearNum + 2; year++) {
      years.push(year.toString());
    }
    return years;
  };

  const years = generateYears();
  const VACATION_PAY_PERCENT = 12;

  const companyAccountUid = activeCompany?.companyAccountUid;

  // Hämta customObEntries från Firestore
  useEffect(() => {
    if (!companyAccountUid) {
      setCustomObEntries([]);
      return;
    }

    const customObRef = collection(db, "users", companyAccountUid, "customObEntries");

    const unsubscribe = onSnapshot(
      customObRef,
      (snapshot) => {
        const entries = snapshot.docs.map((docSnap) => ({
          id: docSnap.id,
          ...docSnap.data(),
        }));
        setCustomObEntries(entries);
      },
      (error) => {
        console.error("Fel vid hämtning av egna OB-tillägg:", error);
        setCustomObEntries([]);
      }
    );

    return () => unsubscribe();
  }, [companyAccountUid]);

  useEffect(() => {
    if (!companyAccountUid) {
      setSalaryTypes([]);
      return;
    }

    const salaryTypesRef = collection(db, "users", companyAccountUid, "salaryTypes");
    const q = query(salaryTypesRef, orderBy("createdAt", "desc"));

    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        const types = [];
        snapshot.forEach((docItem) => {
          types.push({
            id: docItem.id,
            ...docItem.data(),
          });
        });
        setSalaryTypes(types);
      },
      (error) => {
        console.error("Fel vid hämtning av lönetyper:", error);
      }
    );

    return () => unsubscribe();
  }, [companyAccountUid]);

  useEffect(() => {
    setEmployees(previous => {
      let changed = false;
      const updated = previous.map(employee => {
        const salary = salaryTypes.find(item => item.id === employee.draftSalaryTypeId);
        if (!salary) return employee;
        const amount = String(salary.amount ?? "");
        const weeklyHours = salary.weeklyHours ?? 40;
        const monthlyDivisor = salary.monthlyDivisor ?? 0;
        if (employee.draftPayAmount === amount && employee.weeklyHours === weeklyHours && employee.monthlyDivisor === monthlyDivisor) return employee;
        changed = true;
        return { ...employee, draftPayAmount: amount, weeklyHours, monthlyDivisor };
      });
      return changed ? updated : previous;
    });
  }, [salaryTypes, employees]);

  useEffect(() => {
    if (!companyAccountUid) {
      setOvertimeRules([]);
      return;
    }

    const overtimeRulesRef = collection(db, "users", companyAccountUid, "overtimeRules");

    const unsubscribe = onSnapshot(
      overtimeRulesRef,
      (snapshot) => {
        const rules = snapshot.docs.map((docItem) => ({
          id: docItem.id,
          ...docItem.data(),
        }));
        rules.sort((a, b) => (a.name || "").localeCompare(b.name || ""));
        setOvertimeRules(rules);
      },
      (error) => {
        console.error("Fel vid hämtning av övertidsregler:", error);
      }
    );

    return () => unsubscribe();
  }, [companyAccountUid]);

  useEffect(() => {
    if (!companyAccountUid) {
      setAbsenceTypes([]);
      return;
    }

    const absenceTypesRef = collection(db, "users", companyAccountUid, "absenceTypes");

    const unsubscribe = onSnapshot(
      absenceTypesRef,
      (snapshot) => {
        const types = snapshot.docs.map((docItem) => ({
          id: docItem.id,
          ...docItem.data(),
        }));
        types.sort((a, b) => (a.name || "").localeCompare(b.name || ""));
        setAbsenceTypes(types);
      },
      (error) => {
        console.error("Fel vid hämtning av frånvarotyper:", error);
      }
    );

    return () => unsubscribe();
  }, [companyAccountUid]);

  useEffect(() => {
    if (!companyAccountUid) {
      setObRules([]);
      return;
    }

    const obRulesRef = collection(db, "users", companyAccountUid, "obRules");
    const q = query(obRulesRef, orderBy("createdAt", "desc"));

    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        const rules = [];
        snapshot.forEach((docItem) => {
          rules.push({
            id: docItem.id,
            ...docItem.data(),
          });
        });
        setObRules(rules);
      },
      (error) => {
        console.error("Fel vid hämtning av OB-regler:", error);
        setObRules([]);
      }
    );

    return () => unsubscribe();
  }, [companyAccountUid]);

  useEffect(() => {
    if (!companyAccountUid) {
      setHolidays([]);
      return;
    }

    const holidaysRef = collection(db, "users", companyAccountUid, "holidays");
    const q = query(holidaysRef, orderBy("date", "asc"));

    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        const list = [];
        snapshot.forEach((docItem) => {
          list.push({
            id: docItem.id,
            ...docItem.data(),
          });
        });
        setHolidays(list);
      },
      (error) => {
        console.error("Fel vid hämtning av helgdagar:", error);
        setHolidays([]);
      }
    );

    return () => unsubscribe();
  }, [companyAccountUid]);

  useEffect(() => {
    if (!companyAccountUid) {
      setEmployees([]);
      setLoading(false);
      return;
    }

    setLoading(true);

    const employedRef = collection(db, "users", companyAccountUid, "employed");

    const unsubscribe = onSnapshot(
      employedRef,
      (snapshot) => {
        const users = [];

        snapshot.forEach((userDoc) => {
          const userData = userDoc.data();
          const payroll = userData.payroll || {};

          let fullName = userData.name || "";
          if (userData.firstName && userData.lastName) {
            fullName = `${userData.firstName} ${userData.lastName}`;
          } else if (userData.firstName) {
            fullName = userData.firstName;
          } else if (userData.lastName) {
            fullName = userData.lastName;
          } else if (userData.displayName) {
            fullName = userData.displayName;
          } else if (userData.userName) {
            fullName = userData.userName;
          }

          const savedPayType = payroll.savedPayType || "hourly";
          const savedPayAmount =
            payroll.savedPayAmount !== undefined && payroll.savedPayAmount !== null
              ? String(payroll.savedPayAmount)
              : "";

          const savedSalaryTypeId = payroll.savedSalaryTypeId || "";
          const savedSalaryTypeName = payroll.savedSalaryTypeName || "";
          const savedTax = String(payroll.tax ?? 0);
          const savedSemProcent = String(payroll.semProcent ?? 100);
          const savedObEnabled = Boolean(payroll.obEnabled ?? true);
          const savedSemEnabled = Boolean(payroll.semEnabled ?? true);

          users.push({
            id: userDoc.id,
            name: fullName || "Användare",
            email: userData.email || "",
            role: userData.role || "user",

            savedWeeklyHours: payroll.weeklyHours ?? 40,
            savedMonthlyDivisor: payroll.monthlyDivisor ?? 0,
            weeklyHours: payroll.weeklyHours ?? 40,
            monthlyDivisor: payroll.monthlyDivisor ?? 0,
            savedPayType,
            savedPayAmount,
            savedSalaryTypeId,
            savedSalaryTypeName,
            savedSemProcent,
            savedTax,
            savedObEnabled,
            savedSemEnabled,

            draftPayType: savedPayType,
            draftPayAmount: savedPayAmount,
            draftSalaryTypeId: savedSalaryTypeId,
            draftSalaryTypeName: savedSalaryTypeName,
            semProcent: savedSemProcent,
            tax: savedTax,
            obEnabled: savedObEnabled,
            semEnabled: savedSemEnabled,
          });
        });

        users.sort((a, b) => (a.name || "").localeCompare(b.name || "", "sv-SE"));

        setEmployees(users);
        setLoading(false);
      },
      (error) => {
        console.error("Fel vid hämtning av anställda till lön:", error);
        setEmployees([]);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, [companyAccountUid]);

  useEffect(() => {
    if (!companyAccountUid) {
      setShifts([]);
      return;
    }

    const shiftsRef = collection(db, "users", companyAccountUid, "shifts");

    const unsubscribe = onSnapshot(
      shiftsRef,
      (snapshot) => {
        const shiftList = [];
        snapshot.forEach((shiftDoc) => {
          shiftList.push({
            id: shiftDoc.id,
            ...shiftDoc.data(),
          });
        });
        setShifts(shiftList);
      },
      (error) => {
        console.error("Fel vid hämtning av pass:", error);
        setShifts([]);
      }
    );

    return () => unsubscribe();
  }, [companyAccountUid]);

  useEffect(() => {
    if (!companyAccountUid) {
      setBookings([]);
      return;
    }

    const bookingsRef = collection(db, "users", companyAccountUid, "bookings");
    const q = query(bookingsRef, where("status", "in", ["approved", "reserved"]));

    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        const bookingsList = [];
        snapshot.forEach((bookingDoc) => {
          bookingsList.push({
            id: bookingDoc.id,
            ...bookingDoc.data(),
          });
        });
        setBookings(bookingsList);
      },
      (error) => {
        console.error("Fel vid hämtning av bokningar:", error);
        setBookings([]);
      }
    );

    return () => unsubscribe();
  }, [companyAccountUid]);

  useEffect(() => {
    if (!companyAccountUid) {
      setApprovedOvertimeRequests([]);
      return;
    }

    const overtimeRequestsRef = collection(
      db,
      "users",
      companyAccountUid,
      "overtimeRequests"
    );

    const q = query(overtimeRequestsRef, where("status", "==", "approved"));

    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        const requests = snapshot.docs.map((docItem) => ({
          id: docItem.id,
          ...docItem.data(),
        }));

        setApprovedOvertimeRequests(requests);
      },
      (error) => {
        console.error("Fel vid hämtning av godkända övertidsansökningar:", error);
        setApprovedOvertimeRequests([]);
      }
    );

    return () => unsubscribe();
  }, [companyAccountUid]);

  useEffect(() => {
    if (!companyAccountUid) {
      setApprovedAbsenceRequests([]);
      return;
    }

    const absenceRequestsRef = collection(
      db,
      "users",
      companyAccountUid,
      "absenceRequests"
    );

    const q = query(absenceRequestsRef, where("status", "==", "approved"));

    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        const requests = snapshot.docs.map((docItem) => ({
          id: docItem.id,
          ...docItem.data(),
        }));

        setApprovedAbsenceRequests(requests);
      },
      (error) => {
        console.error("Fel vid hämtning av godkända frånvaroansökningar:", error);
        setApprovedAbsenceRequests([]);
      }
    );

    return () => unsubscribe();
  }, [companyAccountUid]);

  useEffect(() => {
    if (!toast.visible) return;

    const timer = setTimeout(() => {
      setToast({ visible: false, message: "", success: true });
    }, 2600);

    return () => clearTimeout(timer);
  }, [toast.visible]);

  const formatHours = (hours) => {
    return (
      Number(hours || 0).toLocaleString("sv-SE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }) + " h"
    );
  };

  const formatCurrency = (amount) => {
    return (
      Number(amount || 0).toLocaleString("sv-SE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }) + " kr"
    );
  };

  const getTaxRate = (taxValue) => {
    const parsedTax = Number(taxValue || 0);
    if (Number.isNaN(parsedTax)) return 0;
    return Math.max(0, Math.min(100, parsedTax));
  };

  const calculateBasePay = (employee, payType, payAmount) => {
    const numericPay = Number(payAmount || 0);

    if (payType === "monthly") {
      return numericPay;
    }

    return numericPay * (
      Number(employee.workedHours || 0) + Number(employee.paidAbsenceHours || 0)
    );
  };

  const calculateVacationPay = (employee, payType, payAmount) => {
    if (!employee?.semEnabled) return 0;

    const basePay = calculateBasePay(employee, payType, payAmount);
    const ordinaryVacationPay = basePay * (VACATION_PAY_PERCENT / 100);
    const semProcent = Number(employee.semProcent || 100);
    return ordinaryVacationPay * (semProcent / 100);
  };

  const calculateTaxAmount = (grossSalary, taxPercent) => {
    const gross = Number(grossSalary || 0);
    const taxRate = getTaxRate(taxPercent);
    return gross * (taxRate / 100);
  };

  const calculateNetSalary = (grossSalary, taxPercent) => {
    const gross = Number(grossSalary || 0);
    const taxAmount = calculateTaxAmount(gross, taxPercent);
    return gross - taxAmount;
  };

  const buildEntries = (shift) =>
    buildEmployeeEntriesFromShift(
      shift,
      bookings,
      approvedOvertimeRequests,
      approvedAbsenceRequests,
      employees,
      overtimeRules,
      absenceTypes
    );

  const workedHoursByEmployee = useMemo(() => {
    const selectedMonthIndex = getMonthIndexFromSwedish(selectedMonth);
    const selectedYearNumber = Number(selectedYear);
    const totals = {};

    shifts.forEach((shift) => {
      const shiftDate = safeParseDate(shift.date);
      if (!shiftDate) return;

      const sameMonth = shiftDate.getMonth() === selectedMonthIndex;
      const sameYear = shiftDate.getFullYear() === selectedYearNumber;
      if (!sameMonth || !sameYear) return;

      const employeeEntries = buildEmployeeEntriesFromShift(
        shift,
        bookings,
        approvedOvertimeRequests,
        approvedAbsenceRequests,
        employees,
        overtimeRules,
        absenceTypes
      );

      employeeEntries.forEach(({ employeeId, employeeData }) => {
        let hours = calculateShiftHours(shift, employeeData);
        const overtime = calculateOvertimeForShift(shift, employeeData);
        hours += overtime.hours;

        totals[employeeId] = (totals[employeeId] || 0) + hours;
      });
    });

    return totals;
  }, [
    shifts,
    selectedMonth,
    selectedYear,
    bookings,
    approvedOvertimeRequests,
    approvedAbsenceRequests,
    employees,
    overtimeRules,
    absenceTypes,
  ]);

  const overtimeByEmployee = useMemo(() => {
    const selectedMonthIndex = getMonthIndexFromSwedish(selectedMonth);
    const selectedYearNumber = Number(selectedYear);
    const totals = {};

    shifts.forEach((shift) => {
      const shiftDate = safeParseDate(shift.date);
      if (!shiftDate) return;

      const sameMonth = shiftDate.getMonth() === selectedMonthIndex;
      const sameYear = shiftDate.getFullYear() === selectedYearNumber;
      if (!sameMonth || !sameYear) return;

      const employeeEntries = buildEmployeeEntriesFromShift(
        shift,
        bookings,
        approvedOvertimeRequests,
        approvedAbsenceRequests,
        employees,
        overtimeRules,
        absenceTypes
      );

      employeeEntries.forEach(({ employeeId, employeeData }) => {
        const overtime = calculateOvertimeForShift(shift, employeeData);

        totals[employeeId] = totals[employeeId] || {
          hours: 0,
          premiumValue: 0,
          regularHours: 0,
          premiumHours: 0,
        };

        totals[employeeId].hours += overtime.hours;
        totals[employeeId].premiumValue += overtime.premiumValue;
        totals[employeeId].regularHours += overtime.regularHours;
        totals[employeeId].premiumHours += overtime.premiumHours;
      });
    });

    return totals;
  }, [
    shifts,
    selectedMonth,
    selectedYear,
    bookings,
    approvedOvertimeRequests,
    approvedAbsenceRequests,
    employees,
    overtimeRules,
    absenceTypes,
  ]);

  const absenceByEmployee = useMemo(() => {
    const selectedMonthIndex = getMonthIndexFromSwedish(selectedMonth);
    const selectedYearNumber = Number(selectedYear);
    const totals = {};

    shifts.forEach((shift) => {
      const shiftDate = safeParseDate(shift.date);
      if (!shiftDate) return;

      const sameMonth = shiftDate.getMonth() === selectedMonthIndex;
      const sameYear = shiftDate.getFullYear() === selectedYearNumber;
      if (!sameMonth || !sameYear) return;

      const employeeEntries = buildEmployeeEntriesFromShift(
        shift,
        bookings,
        approvedOvertimeRequests,
        approvedAbsenceRequests,
        employees,
        overtimeRules,
        absenceTypes
      );

      employeeEntries.forEach(({ employeeId, employeeData }) => {
        const absence = calculateAbsenceForShift(shift, employeeData);

        totals[employeeId] = totals[employeeId] || { hours: 0, value: 0 };
        totals[employeeId].hours += absence.hours;
        totals[employeeId].value += absence.value;
      });
    });

    return totals;
  }, [
    shifts,
    selectedMonth,
    selectedYear,
    bookings,
    approvedOvertimeRequests,
    approvedAbsenceRequests,
    employees,
    overtimeRules,
    absenceTypes,
  ]);

  const employeeMap = useMemo(() => {
    const map = {};
    employees.forEach((employee) => {
      map[employee.id] = employee;
    });
    return map;
  }, [employees]);

  // obTotalsByEmployee - räknar varje OB-källa separat
  const obTotalsByEmployee = useMemo(() => {
    const selectedMonthIndex = getMonthIndexFromSwedish(selectedMonth);
    const selectedYearNumber = Number(selectedYear);
    const totals = {};

    shifts.forEach((shift) => {
      const shiftDate = safeParseDate(shift.date);
      if (!shiftDate) return;

      const sameMonth = shiftDate.getMonth() === selectedMonthIndex;
      const sameYear = shiftDate.getFullYear() === selectedYearNumber;
      if (!sameMonth || !sameYear) return;

      const employeeEntries = buildEmployeeEntriesFromShift(
        shift,
        bookings,
        approvedOvertimeRequests,
        approvedAbsenceRequests,
        employees,
        overtimeRules,
        absenceTypes
      );

      employeeEntries.forEach(({ employeeId, employeeData }) => {
        const employee = employeeMap[employeeId];
        if (!employee) return;

        const employeeCustomObEntries = customObEntries.filter(
          entry => entry.employeeId === employeeId
        );

        const obResult = calculateObForShift(
          shift,
          obRules,
          holidays,
          employee.obEnabled,
          employeeData,
          employeeCustomObEntries
        );

        totals[employeeId] = totals[employeeId] || { hours: 0, value: 0 };
        totals[employeeId].hours += Number(obResult.hours || 0);
        totals[employeeId].value += Number(obResult.value || 0);
      });
    });

    return totals;
  }, [
    shifts,
    selectedMonth,
    selectedYear,
    obRules,
    holidays,
    employeeMap,
    bookings,
    approvedOvertimeRequests,
    approvedAbsenceRequests,
    employees,
    overtimeRules,
    absenceTypes,
    customObEntries,
  ]);

  const employeesWithCalculatedHours = useMemo(() => {
    return employees.map((employee) => {
      const hasSelectedSalary = Boolean(employee.draftSalaryTypeId);
      const workedHours = Number(workedHoursByEmployee[employee.id] ?? 0);
      const calculatedObHours = Number(obTotalsByEmployee[employee.id]?.hours ?? 0);
      const calculatedObValue = hasSelectedSalary
        ? Number(obTotalsByEmployee[employee.id]?.value ?? 0)
        : 0;
      const overtime = overtimeByEmployee[employee.id] || {
        hours: 0,
        premiumValue: 0,
        regularHours: 0,
        premiumHours: 0,
      };
      const absence = absenceByEmployee[employee.id] || { hours: 0, value: 0 };

      const overtimeValue = hasSelectedSalary ? overtimePay(overtime, employee.draftPayType, employee.draftPayAmount, employee) : 0;

      const absencePay = calculateAbsencePay(
        absence,
        employee.draftPayType,
        employee.draftPayAmount,
        employee
      );
      const absenceValue = hasSelectedSalary ? absencePay.deduction : 0;

      const updatedEmployee = {
        ...employee,
        workedHours,
        calculatedObHours,
        calculatedObValue,
        overtimeHoursValue: overtime.hours,
        overtimePremiumHours: overtime.premiumHours,
        overtimeRegularHours: overtime.regularHours,
        overtimeValue,
        absenceHoursValue: absence.hours,
        absenceValue,
        paidAbsenceHours: hasSelectedSalary ? absencePay.paidHours : 0,
      };

      const basePay = hasSelectedSalary
        ? calculateBasePay(
            updatedEmployee,
            employee.draftPayType,
            employee.draftPayAmount
          )
        : 0;

      const vacationPay = hasSelectedSalary
        ? calculateVacationPay(
            updatedEmployee,
            employee.draftPayType,
            employee.draftPayAmount
          )
        : 0;

      const grossSalary =
        basePay +
        calculatedObValue +
        overtimeValue +
        vacationPay -
        absenceValue;

      const taxAmount = calculateTaxAmount(grossSalary, employee.tax);
      const netSalary = calculateNetSalary(grossSalary, employee.tax);

      return {
        ...updatedEmployee,
        basePay,
        vacationPay,
        totalGross: grossSalary,
        totalTax: taxAmount,
        totalNet: netSalary,
        ob: formatCurrency(calculatedObValue),
        obHours: formatHours(calculatedObHours),
        overtime: formatCurrency(overtimeValue),
        vacation: formatCurrency(vacationPay),
        overtimeHours: formatHours(overtime.hours),
        absenceHours: formatHours(absence.hours),
      };
    });
  }, [employees, workedHoursByEmployee, obTotalsByEmployee, overtimeByEmployee, absenceByEmployee]);

  const filteredEmployees = useMemo(() => {
    const q = searchQuery.toLowerCase();

    return employeesWithCalculatedHours.filter(
      (employee) =>
        employee.name.toLowerCase().includes(q) ||
        employee.email.toLowerCase().includes(q) ||
        employee.role.toLowerCase().includes(q)
    );
  }, [employeesWithCalculatedHours, searchQuery]);

  const updateEmployeeDraft = (id, field, value) => {
    setEmployees((prev) =>
      prev.map((employee) =>
        employee.id === id ? { ...employee, [field]: value } : employee
      )
    );
  };

  const getSalaryTypesForPayType = (payType) => {
    return salaryTypes.filter((type) => type.type === payType);
  };

  const findSalaryTypeById = (salaryTypeId) => {
    return salaryTypes.find((type) => type.id === salaryTypeId) || null;
  };

  const handlePayTypeChange = (employeeId, newPayType) => {
    const filteredTypes = getSalaryTypesForPayType(newPayType);

    setEmployees((prev) =>
      prev.map((employee) => {
        if (employee.id !== employeeId) return employee;

        const currentSelected = filteredTypes.find(
          (type) => type.id === employee.draftSalaryTypeId
        );

        if (currentSelected) {
          return {
            ...employee,
            draftPayType: newPayType,
            draftSalaryTypeId: currentSelected.id,
            draftSalaryTypeName: currentSelected.name || "",
            draftPayAmount: String(currentSelected.amount ?? ""),
            weeklyHours: currentSelected.weeklyHours ?? 40,
            monthlyDivisor: currentSelected.monthlyDivisor ?? 0,
          };
        }

        return {
          ...employee,
          draftPayType: newPayType,
          draftSalaryTypeId: "",
          draftSalaryTypeName: "",
          draftPayAmount: "",
        };
      })
    );
  };

  const handleSalaryTypeSelect = (employeeId, salaryTypeId) => {
    const selectedSalaryType = findSalaryTypeById(salaryTypeId);

    setEmployees((prev) =>
      prev.map((employee) => {
        if (employee.id !== employeeId) return employee;

        if (!selectedSalaryType) {
          return {
            ...employee,
            draftSalaryTypeId: "",
            draftSalaryTypeName: "",
            draftPayAmount: "",
          };
        }

        return {
          ...employee,
          draftPayType: selectedSalaryType.type || employee.draftPayType,
          draftSalaryTypeId: selectedSalaryType.id,
          draftSalaryTypeName: selectedSalaryType.name || "",
          draftPayAmount: String(selectedSalaryType.amount ?? ""),
          weeklyHours: selectedSalaryType.weeklyHours ?? 40,
          monthlyDivisor: selectedSalaryType.monthlyDivisor ?? 0,
        };
      })
    );
  };

  const saveEmployeePay = async (id) => {
    if (!companyAccountUid) return;

    const employee = employeesWithCalculatedHours.find((emp) => emp.id === id);
    if (!employee) return;

    try {
      const selectedSalaryType = findSalaryTypeById(employee.draftSalaryTypeId);

      await updateDoc(doc(db, "users", companyAccountUid, "employed", id), {
        payroll: {
          weeklyHours: Number(employee.weeklyHours ?? 40),
          monthlyDivisor: Number(employee.monthlyDivisor ?? 0),
          savedPayType: employee.draftPayType,
          savedPayAmount:
            employee.draftPayAmount === ""
              ? ""
              : Number(employee.draftPayAmount || 0),
          savedSalaryTypeId: employee.draftSalaryTypeId || "",
          savedSalaryTypeName:
            employee.draftSalaryTypeName || selectedSalaryType?.name || "",
          semProcent: Number(employee.semProcent || 100),
          obEnabled: Boolean(employee.obEnabled),
          semEnabled: Boolean(employee.semEnabled),
          workedHours: Number(employee.workedHours || 0),
          overtimeHoursValue: Number(employee.overtimeHoursValue || 0),
          absenceHoursValue: Number(employee.absenceHoursValue || 0),
          obHoursValue: Number(employee.calculatedObHours || 0),
          obValue: Number(employee.calculatedObValue || 0),
          overtimeValue: Number(employee.overtimeValue || 0),
          vacationValue: Number(employee.vacationPay || 0),
          absenceValue: Number(employee.absenceValue || 0),
          tax: Number(employee.tax || 0),
          totalCalculatedGross: Number(employee.totalGross || 0),
          totalCalculatedTax: Number(employee.totalTax || 0),
          totalCalculatedNet: Number(employee.totalNet || 0),
          updatedAt: serverTimestamp(),
        },
        updatedAt: serverTimestamp(),
      });

      setEmployees((prev) =>
        prev.map((emp) =>
          emp.id === id
            ? {
                ...emp,
                savedWeeklyHours: emp.weeklyHours,
                savedMonthlyDivisor: emp.monthlyDivisor,
                savedPayType: emp.draftPayType,
                savedPayAmount: emp.draftPayAmount,
                savedSalaryTypeId: emp.draftSalaryTypeId,
                savedSalaryTypeName: emp.draftSalaryTypeName,
                savedSemProcent: emp.semProcent,
                savedTax: emp.tax,
                savedObEnabled: emp.obEnabled,
                savedSemEnabled: emp.semEnabled,
              }
            : emp
        )
      );

      setToast({ visible: true, message: "Lönen har sparats", success: true });
    } catch (error) {
      console.error("Fel vid sparning av lön:", error);
      setToast({ visible: true, message: "Kunde inte spara lönen", success: false });
    }
  };

  const saveGlobalSettingsToAllEmployees = async (settings) => {
    const updatedHiddenNetSalaries = Object.fromEntries(
      employees.map((employee) => [employee.id, Boolean(settings.hideNetSalary)])
    );
    setHiddenNetSalaries(updatedHiddenNetSalaries);
    localStorage.setItem(
      "payroll-hidden-net-salaries",
      JSON.stringify(updatedHiddenNetSalaries)
    );

    if (!companyAccountUid || employees.length === 0) return;

    try {
      const batch = writeBatch(db);

      employees.forEach((employee) => {
        const employeeRef = doc(db, "users", companyAccountUid, "employed", employee.id);

        batch.update(employeeRef, {
          "payroll.obEnabled": Boolean(settings.obEnabled),
          "payroll.semEnabled": Boolean(settings.semEnabled),
          "payroll.semProcent": Number(settings.semProcent || 0),
          "payroll.tax": Number(settings.tax || 0),
          "payroll.updatedAt": serverTimestamp(),
          updatedAt: serverTimestamp(),
        });
      });

      await batch.commit();

      setEmployees((prev) =>
        prev.map((employee) => ({
          ...employee,
          obEnabled: Boolean(settings.obEnabled),
          semEnabled: Boolean(settings.semEnabled),
          semProcent: String(settings.semProcent),
          tax: String(settings.tax),
          savedObEnabled: Boolean(settings.obEnabled),
          savedSemEnabled: Boolean(settings.semEnabled),
          savedSemProcent: String(settings.semProcent),
          savedTax: String(settings.tax),
        }))
      );

      setToast({
        visible: true,
        message: "Inställningarna har sparats för alla användare",
        success: true,
      });
    } catch (error) {
      console.error("Fel vid sparning av globala inställningar:", error);
      setToast({
        visible: true,
        message: "Kunde inte spara inställningarna för alla",
        success: false,
      });
    }
  };

  const openGlobalSettingsPopup = () => {
    const firstEmployee = filteredEmployees[0] || employees[0];

    setGlobalSettingsDefaults({
      obEnabled: firstEmployee?.obEnabled ?? true,
      semEnabled: firstEmployee?.semEnabled ?? true,
      semProcent: Number(firstEmployee?.semProcent ?? 12),
      tax: Number(firstEmployee?.tax ?? 30),
      hideNetSalary:
        employees.length > 0 &&
        employees.every((employee) => Boolean(hiddenNetSalaries[employee.id])),
    });

    setIsGlobalSettingsPopupOpen(true);
  };

  const handleAddSalary = (salaryData) => {
    console.log("Ny lönetyp sparad:", salaryData);
    setToast({
      visible: true,
      message: `Lönetyp "${salaryData.name}" sparad`,
      success: true,
    });
  };

  const handleAddOb = (obData) => {
    console.log("OB-tillägg sparat:", obData);
    setToast({
      visible: true,
      message: `OB-tillägg sparat för ${obData.employeeName}`,
      success: true,
    });

  };

  const handleAddOvertime = (overtimeData) => {
    console.log("Övertid sparad:", overtimeData);
    setToast({
      visible: true,
      message: `Övertid sparad för ${overtimeData.employeeName}`,
      success: true,
    });

  };

  const handleAddAbsence = (absenceData) => {
    console.log("Frånvaro sparad:", absenceData);
    setToast({
      visible: true,
      message: `Frånvaro registrerad för ${absenceData.employeeName}`,
      success: true,
    });

  };

  const handleSemProcentSave = (percentage) => {
    if (selectedSemProcentEmployee) {
      updateEmployeeDraft(selectedSemProcentEmployee.id, "semProcent", String(percentage));
      setToast({
        visible: true,
        message: `SEM procent ändrad till ${percentage}% för ${selectedSemProcentEmployee.name}`,
        success: true,
      });
    }
  };

  const openSemProcentPopup = (employee) => {
    setSelectedSemProcentEmployee(employee);
    setIsSemProcentPopupOpen(true);
  };

  const handleTimeReportClick = (employee) => {
    setSelectedTimeReportEmployee(employee);
    setIsTimeReportPopupOpen(true);
  };

  const hasChanges = (employee) => {
    return (
      employee.draftPayAmount !== employee.savedPayAmount ||
      employee.weeklyHours !== employee.savedWeeklyHours ||
      employee.monthlyDivisor !== employee.savedMonthlyDivisor ||
      employee.draftPayType !== employee.savedPayType ||
      employee.draftSalaryTypeId !== employee.savedSalaryTypeId ||
      employee.tax !== employee.savedTax ||
      employee.semProcent !== employee.savedSemProcent ||
      employee.obEnabled !== employee.savedObEnabled ||
      employee.semEnabled !== employee.savedSemEnabled
    );
  };

  const styles = {
    page: {
      width: "100%",
      minWidth: 0,
      boxSizing: "border-box",
      background: "#f7f7f8",
      padding: "20px 12px 16px",
      fontFamily:
        'Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
      color: "#111827",
      position: "relative",
    },
    toastWrap: {
      position: "fixed",
      top: "22px",
      right: "22px",
      zIndex: 9999,
      pointerEvents: "none",
      opacity: toast.visible ? 1 : 0,
      transform: toast.visible
        ? "translateY(0) scale(1)"
        : "translateY(-14px) scale(0.96)",
      transition: "all 0.28s ease",
    },
    toastCard: {
      display: "flex",
      alignItems: "center",
      gap: "14px",
      minWidth: "290px",
      maxWidth: "380px",
      padding: "16px 18px",
      borderRadius: "18px",
      background: toast.success
        ? "linear-gradient(135deg, #22c55e 0%, #16a34a 55%, #15803d 100%)"
        : "linear-gradient(135deg, #ef4444 0%, #dc2626 55%, #b91c1c 100%)",
      color: "#ffffff",
      boxShadow: toast.success
        ? "0 18px 40px rgba(22, 163, 74, 0.28)"
        : "0 18px 40px rgba(220, 38, 38, 0.28)",
      border: "1px solid rgba(255,255,255,0.18)",
      backdropFilter: "blur(8px)",
    },
    toastIconWrap: {
      width: "42px",
      height: "42px",
      minWidth: "42px",
      borderRadius: "50%",
      background: "rgba(255,255,255,0.2)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      boxShadow: "inset 0 1px 1px rgba(255,255,255,0.18)",
    },
    toastTextWrap: {
      display: "flex",
      flexDirection: "column",
      gap: "3px",
    },
    toastTitle: {
      fontSize: "15px",
      fontWeight: 800,
      lineHeight: 1.1,
      margin: 0,
    },
    toastSubtitle: {
      fontSize: "12px",
      fontWeight: 500,
      opacity: 0.92,
      margin: 0,
    },
    container: {
      width: "100%",
      minWidth: 0,
      margin: "0 auto",
      display: "flex",
      flexDirection: "column",
      gap: "18px",
    },
    topBar: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      flexWrap: "wrap",
      gap: "14px",
    },
    titleWrap: {
      display: "flex",
      alignItems: "center",
      gap: "10px",
    },
    title: {
      margin: 0,
      fontSize: 24,
      fontWeight: 700,
      color: "#111827",
    },
    filtersRow: {
      display: "flex",
      gap: "10px",
      flexWrap: "wrap",
      alignItems: "center",
    },
    searchWrap: {
      position: "relative",
      minWidth: 0,
      flex: "1 1 320px",
    },
    searchIcon: {
      position: "absolute",
      left: "12px",
      top: "50%",
      transform: "translateY(-50%)",
      color: "#9aa3b2",
      fontSize: "13px",
    },
    searchInput: {
      width: "100%",
      padding: "10px 14px 10px 36px",
      borderRadius: "8px",
      border: "1px solid #d1d5db",
      background: "#fff",
      fontSize: "13px",
      outline: "none",
      boxSizing: "border-box",
    },
    select: {
      fontSize: "13px",
      padding: "10px 12px",
      borderRadius: "8px",
      border: "1px solid #d1d5db",
      backgroundColor: "#fff",
      color: "#111827",
      minWidth: "130px",
    },
    actionButton: {
      padding: "10px 14px",
      borderRadius: "8px",
      border: "1px solid #1677ff",
      backgroundColor: "#1677ff",
      color: "white",
      fontSize: "13px",
      fontWeight: 700,
      cursor: "pointer",
      minWidth: "110px",
      display: "flex",
      alignItems: "center",
      gap: "6px",
      justifyContent: "center",
    },
    gridWrapper: {
      background: "#fff",
      borderRadius: 0,
      border: "1px solid #d1d5db",
      overflowX: "auto",
      boxShadow: "none",
    },
    payrollHeader: {
      display: "grid",
      gridTemplateColumns: "1fr 1.4fr 1fr",
      gap: "14px",
      padding: "16px 18px",
      background: "#f3f4f6",
      borderBottom: "1px solid #d1d5db",
      fontSize: "12px",
      fontWeight: 700,
      color: "#6b7280",
      minWidth: "760px",
    },
    payrollRow: {
      display: "grid",
      gridTemplateColumns: "1fr 1.4fr 1fr",
      gap: "14px",
      padding: "18px",
      borderBottom: "1px solid #eef2f7",
      alignItems: "start",
      minWidth: "760px",
    },
    nameMain: {
      fontWeight: 700,
      color: "#1f2937",
      fontSize: "14px",
      marginBottom: "8px",
    },
    timeReportButton: {
      width: "100%",
      padding: "6px 10px",
      borderRadius: "8px",
      border: "1px solid #10b981",
      backgroundColor: "#ecfdf5",
      color: "#047857",
      fontSize: "11px",
      fontWeight: 600,
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "6px",
      transition: "all 0.2s ease",
      marginTop: "4px",
    },
    payColumn: {
      display: "flex",
      flexDirection: "column",
      gap: "8px",
    },
    payTopRow: {
      display: "flex",
      gap: "8px",
      alignItems: "center",
    },
    payControl: {
      width: "100%",
      padding: "8px 10px",
      borderRadius: "8px",
      border: "1px solid #d1d5db",
      fontSize: "12px",
      background: "#fff",
      boxSizing: "border-box",
    },
    saveButton: {
      padding: "8px 10px",
      borderRadius: "8px",
      border: "1px solid #1677ff",
      backgroundColor: "#1677ff",
      color: "#fff",
      fontSize: "11px",
      fontWeight: 700,
      whiteSpace: "nowrap",
      minWidth: "56px",
      height: "34px",
      transition: "all 0.2s ease",
    },
    chipColumn: {
      display: "flex",
      flexDirection: "column",
      gap: "8px",
    },
    chip: {
      border: "1px solid #e5e7eb",
      borderRadius: "10px",
      padding: "10px 12px",
      background: "#fafbfd",
      display: "flex",
      justifyContent: "space-between",
      gap: "10px",
      fontSize: "12px",
    },
    chipLabel: {
      color: "#6b7280",
      fontWeight: 600,
    },
    chipValue: {
      color: "#111827",
      fontWeight: 700,
    },
    totalChip: {
      border: "1px solid #dbe7ff",
      background: "#f3f7ff",
      borderRadius: "10px",
      padding: "10px 12px",
      display: "flex",
      justifyContent: "space-between",
      gap: "10px",
      fontSize: "12px",
      marginTop: "8px",
    },
    eyeButton: {
      width: 30,
      height: 30,
      padding: 0,
      border: "1px solid #dbe3ef",
      borderRadius: 8,
      background: "#ffffff",
      color: "#64748b",
      cursor: "pointer",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
    },
    taxChip: {
      border: "1px solid #fde2e2",
      background: "#fff5f5",
      borderRadius: "10px",
      padding: "10px 12px",
      display: "flex",
      justifyContent: "space-between",
      gap: "10px",
      fontSize: "12px",
    },
    totalValue: {
      color: "#1d4ed8",
      fontWeight: 800,
    },
    negativeValue: {
      color: "#dc2626",
      fontWeight: 800,
    },
    settingsBox: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: "8px",
      alignItems: "center",
    },
    settingsLabel: {
      fontSize: "12px",
      color: "#6b7280",
      fontWeight: 600,
    },
    settingsControl: {
      width: "100%",
      padding: "8px 10px",
      borderRadius: "8px",
      border: "1px solid #d1d5db",
      fontSize: "12px",
      background: "#fff",
      boxSizing: "border-box",
    },
    semProcentButton: {
      width: "100%",
      padding: "8px 10px",
      borderRadius: "8px",
      border: "1px solid #8b5cf6",
      backgroundColor: "#f5f3ff",
      color: "#6d28d9",
      fontSize: "12px",
      fontWeight: 600,
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      boxSizing: "border-box",
    },
    emptyState: {
      padding: "40px",
      textAlign: "center",
      color: "#6b7280",
      fontWeight: 500,
      background: "#fff",
      borderRadius: 0,
      border: "1px solid #d1d5db",
    },
  };

  if (companyLoading || loading) {
    return <LoadingIndicator message="Laddar löneuppgifter..." fullPage />;
  }

  if (!activeCompany) {
    return (
      <div style={styles.page}>
        <div style={styles.container}>
          <div style={styles.emptyState}>
            <p>Inget företag valt. Vänligen logga in igen.</p>
          </div>
        </div>
      </div>
    );
  }

  if (isTimeReportPopupOpen) {
    return (
      <TimeReportPopup
        isOpen={isTimeReportPopupOpen}
        onClose={() => setIsTimeReportPopupOpen(false)}
        employee={selectedTimeReportEmployee}
        companyRootUid={companyAccountUid}
      />
    );
  }

  if (isSalaryPopupOpen) {
    return (
      <AddSalaryPopup
        isOpen
        key={companyAccountUid}
        companyRootUid={companyAccountUid}
        onClose={() => setIsSalaryPopupOpen(false)}
        onSave={handleAddSalary}
      />
    );
  }

  if (isObPopupOpen) {
    return (
      <AddObPopup
        isOpen={isObPopupOpen}
        onClose={() => setIsObPopupOpen(false)}
        onSave={handleAddOb}
        employees={employees}
      />
    );
  }

  if (isOvertimePopupOpen) {
    return (
      <AddOvertimePopup
        isOpen={isOvertimePopupOpen}
        onClose={() => setIsOvertimePopupOpen(false)}
        onSave={handleAddOvertime}
        employees={employees}
      />
    );
  }

  if (isAbsencePopupOpen) {
    return (
      <AddAbsencePopup
        isOpen={isAbsencePopupOpen}
        onClose={() => setIsAbsencePopupOpen(false)}
        onSave={handleAddAbsence}
        employees={employees}
      />
    );
  }

  return (
    <div className="payroll-overview" style={styles.page}>
      <div style={styles.toastWrap}>
        <div style={styles.toastCard}>
          <div style={styles.toastIconWrap}>
            <FaCheck size={16} />
          </div>
          <div style={styles.toastTextWrap}>
            <p style={styles.toastTitle}>{toast.message}</p>
            <p style={styles.toastSubtitle}>
              {toast.success ? "Ändringen har registrerats" : "Försök igen"}
            </p>
          </div>
        </div>
      </div>







      <SemProcentPopup
        isOpen={isSemProcentPopupOpen}
        onClose={() => setIsSemProcentPopupOpen(false)}
        onSave={handleSemProcentSave}
        currentValue={selectedSemProcentEmployee?.semProcent}
      />

      <GlobalSettingsPopup
        isOpen={isGlobalSettingsPopupOpen}
        onClose={() => setIsGlobalSettingsPopupOpen(false)}
        onSave={saveGlobalSettingsToAllEmployees}
        initialValues={globalSettingsDefaults}
      />



      <div style={styles.container}>
        <div style={{ marginBottom: 16 }}>
          <p style={{ color: "#6b7280", fontSize: 14, margin: 0 }}>
            Visar lön för: <strong>{activeCompany?.companyName}</strong>
          </p>
        </div>

        <div style={styles.topBar}>
          <div style={styles.titleWrap}>
            <h1 style={{ ...styles.title, display: "flex", alignItems: "center", gap: 12, fontWeight: 800 }}><FaMoneyBill color="#1677ff" aria-hidden="true" />Lönhantering</h1>
          </div>
        </div>

        <div className="payroll-overview-filters" style={styles.filtersRow}>
          <div style={styles.searchWrap}>
            <FaSearch style={styles.searchIcon} />
            <input
              type="text"
              placeholder="Sök namn, email, roll..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              style={styles.searchInput}
            />
          </div>

          <select
            value={selectedMonth}
            onChange={(e) => setSelectedMonth(e.target.value)}
            style={styles.select}
          >
            {monthsInSwedish.map((month) => (
              <option key={month} value={month}>
                {month}
              </option>
            ))}
          </select>

          <select
            value={selectedYear}
            onChange={(e) => setSelectedYear(e.target.value)}
            style={styles.select}
          >
            {years.map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </select>

        <nav className="payroll-overview-actions" aria-label="Hantera löneregler">
          <button style={styles.actionButton} onClick={() => setIsSalaryPopupOpen(true)}>
            <FaPlus /> Löner
          </button>

          <button style={styles.actionButton} onClick={() => setIsObPopupOpen(true)}>
            <FaPlus /> OB
          </button>

          <button style={styles.actionButton} onClick={() => setIsOvertimePopupOpen(true)}>
            <FaPlus /> Övertid
          </button>

          <button style={styles.actionButton} onClick={() => setIsAbsencePopupOpen(true)}>
            <FaPlus /> Frånvaro
          </button>

          <button style={styles.actionButton} onClick={openGlobalSettingsPopup}>
            <FaPlus /> Inställningar alla
          </button>
        </nav>
        </div>

        {loading ? (
          <LoadingIndicator message="Laddar anställda..." />
        ) : filteredEmployees.length === 0 ? (
          <div style={styles.emptyState}>Inga anställda hittades.</div>
        ) : (
          <div className="payroll-employee-table" style={styles.gridWrapper}>
            <div className="payroll-employee-header" style={styles.payrollHeader}>
              <span>Namn</span>
              <span>Lön</span>
              <span>Inställningar &amp; skatt</span>
              <span>Åtgärder</span>
            </div>

            {filteredEmployees.map((employee, index) => {
              const filteredSalaryOptions = getSalaryTypesForPayType(employee.draftPayType);

              return (
                <div
                  key={employee.id}
                  className="payroll-employee-row"
                  style={{
                    ...styles.payrollRow,
                    borderBottom:
                      index === filteredEmployees.length - 1
                        ? "none"
                        : "1px solid #eef2f7",
                  }}
                >
                  <span>
                    <div style={styles.nameMain}>{employee.name}</div>
                    <button
                      className="payroll-time-report-button"
                      style={styles.timeReportButton}
                      onClick={() => handleTimeReportClick(employee)}
                    >
                      <FaClock size={11} />
                      Tidsrapport
                    </button>
                  </span>

                  <span>
                    <div className="payroll-employee-pay" style={styles.payColumn}>
                      <div style={styles.payTopRow}>
                        <select
                          aria-label={`Lönetyp för ${employee.name}`}
                          value={employee.draftPayType}
                          onChange={(e) => handlePayTypeChange(employee.id, e.target.value)}
                          style={styles.payControl}
                        >
                          <option value="monthly">Månadslön</option>
                          <option value="hourly">Timlön</option>
                        </select>


                      </div>

                      <select
                        aria-label={`Lön för ${employee.name}`}
                        value={employee.draftSalaryTypeId || ""}
                        onChange={(e) => handleSalaryTypeSelect(employee.id, e.target.value)}
                        style={styles.payControl}
                      >
                        <option value="">
                          {employee.draftPayType === "hourly"
                            ? "Välj timlön"
                            : "Välj månadslön"}
                        </option>

                        {filteredSalaryOptions.map((salaryType) => (
                          <option key={salaryType.id} value={salaryType.id}>
                            {salaryType.name} – {Number(salaryType.amount || 0).toLocaleString("sv-SE")} kr
                            {salaryType.type === "hourly" ? "/tim" : "/mån"}
                          </option>
                        ))}
                      </select>
                    </div>
                  </span>

                  <span>
                    <div className="payroll-employee-settings" style={styles.settingsBox}>
                      <div className="payroll-setting-field">
                      <div style={styles.settingsLabel}>OB</div>
                      <select
                        style={styles.settingsControl}
                        value={employee.obEnabled ? "on" : "off"}
                        onChange={(e) =>
                          updateEmployeeDraft(employee.id, "obEnabled", e.target.value === "on")
                        }
                      >
                        <option value="on">På</option>
                        <option value="off">Av</option>
                      </select>
                      </div>

                      <div className="payroll-setting-field">
                      <div style={styles.settingsLabel}>Sem</div>
                      <select
                        style={styles.settingsControl}
                        value={employee.semEnabled ? "on" : "off"}
                        onChange={(e) =>
                          updateEmployeeDraft(employee.id, "semEnabled", e.target.value === "on")
                        }
                      >
                        <option value="on">På</option>
                        <option value="off">Av</option>
                      </select>
                      </div>

                      <div className="payroll-setting-field">
                      <div style={styles.settingsLabel}>SEM %</div>
                      <button
                        style={styles.semProcentButton}
                        onClick={() => openSemProcentPopup(employee)}
                      >
                        <span>{employee.semProcent || 100}%</span>
                        <FaPercentage size={12} />
                      </button>
                      </div>

                      <div className="payroll-setting-field">
                      <div style={styles.settingsLabel}>Skatt %</div>
                      <input
                        type="number"
                        min="0"
                        max="100"
                        value={employee.tax}
                        onChange={(e) => updateEmployeeDraft(employee.id, "tax", e.target.value)}
                        style={styles.settingsControl}
                      />
                      </div>
                    </div>

                  </span>
                  <div className="payroll-employee-save">
                        <button
                          style={{
                            ...styles.saveButton,
                            opacity: hasChanges(employee) ? 1 : 0.45,
                            cursor: hasChanges(employee) ? "pointer" : "not-allowed",
                          }}
                          disabled={!hasChanges(employee)}
                          onClick={() => saveEmployeePay(employee.id)}
                        >
                          Spara
                        </button>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}

registerStyles("PayrollOverview", `
.payroll-overview { background: #f8fafc !important; }
.payroll-employee-header, .payroll-employee-row { grid-template-columns: minmax(150px, .75fr) minmax(200px, 1fr) minmax(400px, 1.8fr) 68px !important; gap: 16px !important; min-width: 980px !important; }
.payroll-employee-header { color: #64748b !important; font-size: 11px !important; font-weight: 700 !important; padding: 10px 16px !important; text-transform: uppercase; letter-spacing: .04em; }
.payroll-employee-row { padding: 12px 16px !important; align-items: center !important; }
.payroll-employee-row > span { min-width: 0; }
.payroll-employee-pay { display: grid !important; grid-template-columns: minmax(0, .85fr) minmax(0, 1.15fr); align-items: center; gap: 8px !important; }
.payroll-employee-pay > div, .payroll-employee-pay select { width: 100% !important; min-width: 0 !important; }
.payroll-employee-pay select, .payroll-employee-settings select, .payroll-employee-settings input, .payroll-employee-settings button { height: 32px !important; min-height: 32px !important; font-size: 12px !important; }
.payroll-employee-settings { grid-template-columns: repeat(4, minmax(0, 1fr)) !important; gap: 8px !important; }
.payroll-setting-field { display: flex; flex-direction: column; gap: 4px; min-width: 0; }
.payroll-setting-field > div { font-size: 11px !important; }
.payroll-employee-row > span:first-child > div { font-size: 13px !important; margin-bottom: 6px !important; }
.payroll-employee-row .payroll-time-report-button { width: auto !important; padding: 4px 9px !important; margin-top: 0 !important; font-size: 11px !important; }
.payroll-employee-save { display: flex; justify-content: flex-end; }
.payroll-employee-save button { height: 30px !important; min-width: 54px !important; padding: 0 9px !important; font-size: 12px !important; }
.payroll-overview-filters { display: grid !important; grid-template-columns: minmax(220px, 1fr) 132px 104px; gap: 10px 12px !important; padding: 14px !important; background: #fff; border: 1px solid #e2e8f0; border-radius: 12px; }
.payroll-overview-filters input, .payroll-overview-filters select { height: 38px !important; min-width: 0 !important; width: 100%; box-sizing: border-box; font-size: 13px !important; }
.payroll-overview-filters > div:first-child { min-width: 0; }
.payroll-overview-actions { grid-column: 1 / -1; display: flex; flex-wrap: wrap; gap: 8px; padding-top: 10px; border-top: 1px solid #f1f5f9; }
.payroll-overview-actions button { min-height: 34px !important; padding: 0 12px !important; font-size: 13px !important; border-radius: 7px !important; background: #fff !important; color: #334155 !important; border: 1px solid #e2e8f0 !important; font-weight: 600 !important; }
.payroll-overview-actions button:hover { background: #f8fafc !important; border-color: #cbd5e1 !important; }
.payroll-employee-table { border-color: #e2e8f0 !important; border-radius: 12px !important; }
.payroll-overview button:focus-visible, .payroll-overview input:focus-visible, .payroll-overview select:focus-visible { outline: 2px solid #1677ff; outline-offset: 2px; }
@media (max-width: 760px) { .payroll-overview-filters { grid-template-columns: minmax(0, 1fr) minmax(110px, .7fr) minmax(86px, .5fr); } .payroll-overview-actions button { flex: 1 1 120px; } }
@media (max-width: 480px) { .payroll-overview-filters { grid-template-columns: 1fr 1fr; } .payroll-overview-filters > div:first-child { grid-column: 1 / -1; } }
`);
